import Link from 'next/link';
import styled from 'styled-components';

export const ChipsGrid = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 291px));
  gap: 12px;
  padding: 0 16px;

  @media (min-width: 620px) {
    grid-template-columns: repeat(3, minmax(0, 291px));
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(4, minmax(0, 291px));
    padding: 0;
  }

  @media (min-width: 960px) and (max-width: 1280px) {
    padding: 0 20px;
  }
`;

export const ChipLink = styled(Link)`
  display: flex;
  min-height: 70px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
    var(--dct--customized-colors-buttonsLinks, #456bd9);

  &:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%),
      var(--dct--customized-colors-buttonsLinks, #456bd9);
  }

  &:focus-visible {
    outline: 2px solid var(--dct--customized-colors-buttonsLinks, #456bd9);
    outline-offset: 2px;
  }
`;

export const ChipLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: var(--dct--customized-colors-buttonsLinks, #456bd9);
  line-height: 120%;
`;

export const ChipIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--dct--customized-colors-buttonsLinks, #456bd9);

  svg {
    width: 20px;
    height: 20px;
  }
`;
